(function () {
  var drawer, overlay, bodyEl, footerEl;
  var pendingDiscount = '';

  function money(cents) {
    var amount = cents / 100;
    if (window.Shopify && Shopify.currency && Shopify.currency.active) {
      try {
        return new Intl.NumberFormat(navigator.language || 'en', {
          style: 'currency',
          currency: Shopify.currency.active,
          minimumFractionDigits: 2
        }).format(amount);
      } catch (e) {}
    }
    return '€' + amount.toFixed(2);
  }

  function open() {
    drawer.classList.add('is-open');
    overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    fetchAndRender();
  }

  function close() {
    drawer.classList.remove('is-open');
    overlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  function fetchAndRender() {
    bodyEl.innerHTML = '<div class="vcd__loading">Loading…</div>';
    footerEl.innerHTML = '';
    fetch('/cart.js', { headers: { 'Content-Type': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { render(cart); updateBubble(cart.item_count); })
      .catch(function () {
        bodyEl.innerHTML = '<div class="vcd__empty">Unable to load cart.</div>';
      });
  }

  function itemHtml(item) {
    var imgSrc = item.featured_image && item.featured_image.url
      ? item.featured_image.url
      : (item.image || '');
    if (imgSrc && imgSrc.indexOf('?') === -1) imgSrc += '?width=160';
    var variantLine = (item.variant_title && item.variant_title !== 'Default Title')
      ? '<p class="vcd__item-variant">' + item.variant_title + '</p>'
      : '';
    return (
      '<div class="vcd__item" data-key="' + item.key + '">' +
        (imgSrc
          ? '<a href="' + item.url + '" class="vcd__item-img-wrap"><img class="vcd__item-img" src="' + imgSrc + '" alt="" loading="lazy"></a>'
          : '<div class="vcd__item-img-wrap"></div>') +
        '<div class="vcd__item-details">' +
          '<div class="vcd__item-row">' +
            '<a href="' + item.url + '" class="vcd__item-title">' + item.product_title.toUpperCase() + '</a>' +
            '<span class="vcd__item-price">' + money(item.final_line_price) + '</span>' +
          '</div>' +
          variantLine +
          '<div class="vcd__item-row vcd__item-actions">' +
            '<div class="vcd__qty">' +
              '<button class="vcd__qty-btn" data-action="decrease" data-key="' + item.key + '" data-qty="' + item.quantity + '">—</button>' +
              '<span class="vcd__qty-val">' + item.quantity + '</span>' +
              '<button class="vcd__qty-btn" data-action="increase" data-key="' + item.key + '" data-qty="' + item.quantity + '">+</button>' +
            '</div>' +
            '<button class="vcd__remove" data-key="' + item.key + '" aria-label="Remove">' +
              '<svg width="14" height="14" viewBox="0 0 14 14" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round">' +
                '<line x1="2" y1="2" x2="12" y2="12"/><line x1="12" y1="2" x2="2" y2="12"/>' +
              '</svg>' +
            '</button>' +
          '</div>' +
        '</div>' +
      '</div>'
    );
  }

  function render(cart) {
    if (cart.item_count === 0) {
      bodyEl.innerHTML = '<div class="vcd__empty">Your cart is empty.</div>';
      footerEl.innerHTML = '';
      return;
    }

    bodyEl.innerHTML = cart.items.map(function (item, i) {
      return (i > 0 ? '<hr class="vcd__divider">' : '') + itemHtml(item);
    }).join('');

    var discountInputVal = pendingDiscount
      ? 'value="' + pendingDiscount.replace(/"/g, '&quot;') + '"'
      : '';

    footerEl.innerHTML =
      '<div class="vcd__subtotal">' +
        '<span class="vcd__subtotal-label">Subtotal</span>' +
        '<span class="vcd__subtotal-price">' + money(cart.total_price) + '</span>' +
      '</div>' +
      '<div class="vcd__discount">' +
        '<input class="vcd__discount-input" id="vcd-discount-input" type="text" placeholder="DISCOUNT CODE" ' + discountInputVal + '>' +
        '<button class="vcd__discount-btn" id="vcd-discount-apply">APPLY</button>' +
      '</div>' +
      '<p class="vcd__discount-msg" id="vcd-discount-msg"></p>' +
      '<div class="vcd__apple-pay-wrap" id="vcd-apple-pay-wrap">' +
        '<button class="vcd__apple-pay" id="vcd-apple-pay" aria-label="Pay with Apple Pay"></button>' +
      '</div>' +
      '<button class="vcd__checkout" id="vcd-checkout">CONTINUE TO CHECKOUT</button>';

    bindEvents();
  }

  function bindEvents() {
    // Quantity buttons
    bodyEl.querySelectorAll('.vcd__qty-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var key = btn.dataset.key;
        var qty = parseInt(btn.dataset.qty, 10);
        var newQty = btn.dataset.action === 'increase' ? qty + 1 : Math.max(0, qty - 1);
        changeQty(key, newQty);
      });
    });

    // Remove buttons
    bodyEl.querySelectorAll('.vcd__remove').forEach(function (btn) {
      btn.addEventListener('click', function () {
        changeQty(btn.dataset.key, 0);
      });
    });

    // Discount apply
    var applyBtn = document.getElementById('vcd-discount-apply');
    var discountInput = document.getElementById('vcd-discount-input');
    var discountMsg = document.getElementById('vcd-discount-msg');

    if (applyBtn && discountInput) {
      applyBtn.addEventListener('click', function () {
        var code = discountInput.value.trim();
        if (!code) return;
        pendingDiscount = code;
        discountMsg.textContent = '✓ Code saved — applied at checkout.';
        discountMsg.className = 'vcd__discount-msg vcd__discount-msg--ok';
      });
      discountInput.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') applyBtn.click();
      });
    }

    // Checkout
    var checkoutBtn = document.getElementById('vcd-checkout');
    if (checkoutBtn) {
      checkoutBtn.addEventListener('click', function () {
        if (pendingDiscount) {
          window.location.href = '/discount/' + encodeURIComponent(pendingDiscount) + '?redirect=/checkout';
        } else {
          window.location.href = '/checkout';
        }
      });
    }

    // Apple Pay — show only when the browser supports it
    var appleWrap = document.getElementById('vcd-apple-pay-wrap');
    var appleBtn  = document.getElementById('vcd-apple-pay');
    if (appleWrap && appleBtn && window.ApplePaySession && ApplePaySession.canMakePayments()) {
      appleWrap.style.display = 'block';
      appleBtn.addEventListener('click', function () {
        if (pendingDiscount) {
          window.location.href = '/discount/' + encodeURIComponent(pendingDiscount) + '?redirect=/checkout';
        } else {
          window.location.href = '/checkout';
        }
      });
    }
  }

  function changeQty(key, qty) {
    // Optimistic UI: disable buttons during request
    bodyEl.querySelectorAll('.vcd__qty-btn, .vcd__remove').forEach(function (b) { b.disabled = true; });

    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) { render(cart); updateBubble(cart.item_count); })
      .catch(function () { fetchAndRender(); });
  }

  function updateBubble(count) {
    // Mobile menu CART label keeps the same count
    document.querySelectorAll('[data-vh-menu-count]').forEach(function (el) {
      el.textContent = count > 0 ? ' (' + count + ')' : '';
    });
    var bubble = document.querySelector('.cart-count-bubble');
    if (!bubble) return;
    if (count === 0) {
      bubble.style.display = 'none';
      return;
    }
    bubble.style.display = '';
    var span = bubble.querySelector('[aria-hidden]');
    if (span) span.textContent = count < 100 ? count : '';
  }

  function init() {
    drawer  = document.getElementById('vcd');
    overlay = document.getElementById('vcd-overlay');
    bodyEl  = document.getElementById('vcd-body');
    footerEl = document.getElementById('vcd-footer');
    if (!drawer) return;

    overlay.addEventListener('click', close);
    document.getElementById('vcd-close').addEventListener('click', close);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) close();
    });

    // Intercept cart icon click
    document.addEventListener('click', function (e) {
      if (e.target.closest('#cart-icon-bubble')) {
        e.preventDefault();
        open();
      }
    });

    // Intercept add-to-cart form submissions — open drawer after adding
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form || !form.action) return;
      var action = form.getAttribute('action') || '';
      if (action.indexOf('/cart/add') === -1) return;
      e.preventDefault();

      var submitBtn = form.querySelector('[type="submit"]');
      if (submitBtn) submitBtn.disabled = true;

      fetch('/cart/add.js', { method: 'POST', body: new FormData(form) })
        .then(function (r) { return r.json(); })
        .then(function () {
          if (submitBtn) submitBtn.disabled = false;
          open();
        })
        .catch(function () {
          // Fall back to normal submission if AJAX fails
          if (submitBtn) submitBtn.disabled = false;
          form.submit();
        });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
